import {SvgIcon, SvgIconProps} from '@mui/material';

const Payment = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg
                id="تسهیلات"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
            >
                <g id="Group_144211" data-name="Group 144211">
                    <rect
                        id="Rectangle_2599"
                        data-name="Rectangle 2599"
                        width="20"
                        height="20"
                        fill="none"
                    />
                </g>
                <rect
                    id="Rectangle_2600"
                    data-name="Rectangle 2600"
                    width="3.333"
                    height="9.167"
                    transform="translate(0.833 9.167)"
                    fill="var(--tirnary-text-color)"
                />
                <path
                    id="Path_41403"
                    data-name="Path 41403"
                    d="M17.833,16H12l-1.742-.608.275-.783L12,15.167h2.35a.985.985,0,0,0,.983-.983h0a1,1,0,0,0-.642-.925L8.642,11H7v7.517l5.833,1.65,6.675-2.5h0A1.679,1.679,0,0,0,17.833,16Z"
                    transform="translate(-1.167 -1.833)"
                    fill="var(--tirnary-text-color)"
                />
                <path
                    id="Path_41401"
                    data-name="Path 41401"
                    d="M6.583,2a4.583,4.583,0,1,0,4.583,4.583A4.585,4.585,0,0,0,6.583,2Zm.4,7.223v.568h-.8V9.2A1.85,1.85,0,0,1,4.8,7.844l.756-.307a1.211,1.211,0,0,0,1.1.958c.426,0,.907-.22.907-.738,0-.44-.321-.669-1.045-.93-.5-.179-1.535-.472-1.535-1.517a1.411,1.411,0,0,1,1.2-1.357V3.375h.8v.568A1.57,1.57,0,0,1,8.206,4.965l-.724.307a.886.886,0,0,0-.871-.614c-.321,0-.83.17-.83.637,0,.435.394.6,1.21.871,1.1.38,1.38.94,1.38,1.581A1.519,1.519,0,0,1,6.987,9.223Z"
                    transform="translate(7.167 -0.333)"
                    fill="var(--tirnary-text-color)"
                />
            </svg>
        </SvgIcon>
    );
};

export default Payment;
